import BusinessUnitResourceModel from '../../generated/types/model/resource/BusinessUnitResourceModel';

export default class BusinessUnitResourceViewModel extends BusinessUnitResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
